// extracted by mini-css-extract-plugin
export default {"hidden":"hidden__2nktn"};